import { render, staticRenderFns } from "./SpecimensReportsSons.vue?vue&type=template&id=396d88b8"
import script from "./SpecimensReportsSons.vue?vue&type=script&lang=js"
export * from "./SpecimensReportsSons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports